import http from './api'

const route = 'app/comercialpersonalizacao/'

export default {
  showFiltrosPagina: (dataInicio, dataFim, username, tokenContrato) => {
    return http.post(route + 'showFiltrosPagina', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      username: username,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoClienteTempo: (dataInicial, dataFinal, empresas, cidades, areas, vendedores, redes, clientes, produtos, clienteIds, tokenContrato, dataInicial1, dataFinal1) => {
    return http.post(route + 'showFaturamentoClienteTempo', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresas,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      clientes: clientes,
      clienteIds: clienteIds,
      produtos: produtos,
      tokenContrato: tokenContrato,
      dataInicial1: dataInicial1,
      dataFinal1: dataFinal1,
    })
  },

  showFaturamentoxLinha: (dataInicial, dataFinal, empresas, cidades, areas, vendedores, redes, tokenContrato) => {
    return http.post(route + 'showFaturamentoxLinha', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresas,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokenContrato,
    })
  },

  showAnosFaturamento: (tokenContrato) => {
    return http.post(route + 'showAnosFaturamento', {
      tokenContrato: tokenContrato,
    })
  },

  showFat: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showFat', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFatDevolucao: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showFatDevolucao', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showKgFaturados: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showKgFaturados', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFaturamentoLinha: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFaturamentoLinha', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFaturamentoKgLinha: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFaturamentoKgLinha', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFaturamentoPrecoMedio: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFaturamentoPrecoMedio', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoClassificacaoMes: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showFaturamentoClassificacaoMes', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showCompartivoFaturamentoMes: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showCompartivoFaturamentoMes', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoPorcentagemFaturamentoVendedor: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoPorcentagemFaturamentoVendedor', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFaturamentoMetaVendedores: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFaturamentoMetaVendedores', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoDevolucaoImpropriasVendedores: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoDevolucaoImpropriasVendedores', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoDevolucaoOrcadoVendedores: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoDevolucaoOrcadoVendedores', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFaturamentoVendedorxMeta: (selectVendedor, selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFaturamentoVendedorxMeta', {
      selectVendedor: selectVendedor,
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFaturamentoMetaVendedorClassificacao: (selectVendedor, selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFaturamentoMetaVendedorClassificacao', {
      selectVendedor: selectVendedor,
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFatPrecoMedioClassificacaoVendedores: (selectVendedor, selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFatPrecoMedioClassificacaoVendedores', {
      selectVendedor: selectVendedor,
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showTotalKilosFaturadosVendedor: (selectVendedor, selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showTotalKilosFaturadosVendedor', {
      selectVendedor: selectVendedor,
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoDevolucaoImpropriaVendedor: (selectVendedor, selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showFaturamentoDevolucaoImpropriaVendedor', {
      selectVendedor: selectVendedor,
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoDevolucaoOrcadoClassificacaoVendedores: (selectVendedor, selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoDevolucaoOrcadoClassificacaoVendedores', {
      selectVendedor: selectVendedor,
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoKgTotalClassificacaoVendedor: (selectVendedor, selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoKgTotalClassificacaoVendedor', {
      selectVendedor: selectVendedor,
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showFatRedes: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showFatRedes', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFaturamentoRedes: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFaturamentoRedes', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFaturamentoRedesKg: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFaturamentoRedesKg', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoFaturamentoRedesRS: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showGraficoFaturamentoRedesRS', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showCoberturaVendedor: (selectRedes, selectMes, selectAno, selectSupervisor, tokenContrato) => {
    return http.post(route + 'showCoberturaVendedor', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      selectSupervisor: selectSupervisor,
      tokenContrato: tokenContrato,
    })
  },

  showDetalheCoberturaVendedor: (selectRedes, selectMes, selectAno, tokenContrato) => {
    return http.post(route + 'showDetalheCoberturaVendedor', {
      selectRedes: selectRedes,
      selectMes: selectMes,
      selectAno: selectAno,
      tokenContrato: tokenContrato,
    })
  },

  showProvisaoComissao: (dataInicial, dataFinal, empresa, vendedores, tokenContrato) => {
    return http.post(route + 'showProvisaoComissao', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresa: empresa,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoSemanal: (selectMes, selectAno, vendedores, tokenContrato) => {
    return http.post(route + 'showFaturamentoSemanal', {
      selectMes: selectMes,
      selectAno: selectAno,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },

  showMetaVendedor: (selectMes, selectAno, vendedores, tokenContrato) => {
    return http.post(route + 'showMetaVendedor', {
      selectMes: selectMes,
      selectAno: selectAno,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },

  showValorDevolucao: (selectMes, selectAno, vendedores, tokenContrato) => {
    return http.post(route + 'showValorDevolucao', {
      selectMes: selectMes,
      selectAno: selectAno,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },

  showGraficoDevolucao: (selectMes, selectAno, vendedores, tokenContrato) => {
    return http.post(route + 'showGraficoDevolucao', {
      selectMes: selectMes,
      selectAno: selectAno,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },

  showTotalDevolucaoQuebra: (selectMes, selectAno, vendedores, tokenContrato) => {
    return http.post(route + 'showTotalDevolucaoQuebra', {
      selectMes: selectMes,
      selectAno: selectAno,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },

  showDevolucaoTroca: (selectMes, selectAno, vendedores, tokenContrato) => {
    return http.post(route + 'showDevolucaoTroca', {
      selectMes: selectMes,
      selectAno: selectAno,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },

  showTotalDevolucao: (selectMes, selectAno, vendedores, tokenContrato) => {
    return http.post(route + 'showTotalDevolucao', {
      selectMes: selectMes,
      selectAno: selectAno,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },
}
